import { useQueryClient } from 'react-query';
import {
  useTracking,
  setTrackView,
  setTrackLink,
  setTrackWithNewDatalayer,
} from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';
import { isAppLockin } from './shoppingCart.utils';
import { useCheckout } from '../iBuyFixed.context';
import { getTagging, getUserInfo } from '../Checkout/checkout.utils';
import { IShoppingCartResponse } from '@vfit/consumer/data-access';

const ShoppingCartTagging = () => {
  const { product } = useCheckout();
  const queryClient = useQueryClient();
  const tagging = getTagging('cart', 'fixed', queryClient);
  const hasCampaignAcceptedIadd = queryClient?.getQueryData(
    'getShoppingCartLockIn',
  ) as IShoppingCartResponse;
  const hasCampaignAcceptedMM = queryClient?.getQueryData(
    'getShoppingCartLockIn',
  ) as IShoppingCartResponse;

  const hasCampaignAcceptedHUB =
    typeof window !== 'undefined'
      ? localStorage.getItem('LOCK_IN_IS_ACCEPTED_FROM_HUB')?.toString() === 'true'
      : false;

  const isLockIn =
    !!hasCampaignAcceptedIadd?.id?.toString() ||
    !!hasCampaignAcceptedMM?.id?.toString() ||
    product?.isCvm ||
    !!localStorage.getItem('startFromlockIn') ||
    hasCampaignAcceptedHUB;

  const pageType = isLockIn ? 'cart lock-in' : 'cart';
  const event = isLockIn ? ['cart_view_lockin'] : ['cart_view'];

  const { trackWithNewDatalayer, trackView } = useTracking({
    event: event,
    opts: {
      ...tagging?.opts,
      ...(pageType === 'cart lock-in' && { event_label: 'cart_view_lockin' }),
    },
    cartProduct: {
      ...tagging?.trackingProduct,
      cart_total: product?.price && removeCurrency(product.price),
    },
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
    disableInitialTrack: isAppLockin(),
  });
  setTrackView(trackView);
  setTrackLink(trackView);
  setTrackWithNewDatalayer(trackWithNewDatalayer);

  return null;
};

export default ShoppingCartTagging;

